import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SuccessStories, successStoriesStateFeatureKey } from './reducer';

export const selectSuccessStories = createFeatureSelector<{
  successStoriesData: SuccessStories;
}>(successStoriesStateFeatureKey);

export const selectSuccessStoriesData = createSelector(
  selectSuccessStories,
  state => {
    return state?.successStoriesData?.stories;
  }
);

export const selectSuccessStoriesAllData = createSelector(
  selectSuccessStories,
  state => state
);

export const selectPages = createSelector(
  selectSuccessStories,
  state => state?.successStoriesData?.pages
);

export const selectIsLoadingSuccessStory = createSelector(
  selectSuccessStories,
  state => state?.successStoriesData?.isLoading
);
export const selectIsLoadingStoriesSuccessStory = createSelector(
  selectSuccessStories,
  state => state?.successStoriesData?.isLoadingStories
);

export const selectIsHandlingStoryChange = createSelector(
  selectSuccessStories,
  state => state?.successStoriesData?.isHandlingStoryChange
);

export const selectHandledStoryChangeSuccessfully = createSelector(
  selectSuccessStories,
  state => state?.successStoriesData?.handledStorySuccessfully
);

export const selectUpdatedId = createSelector(
  selectSuccessStories,
  state => state?.successStoriesData?.updatedId
);

export const selectSuccessStoryById = createSelector(
  selectSuccessStories,
  state => state?.successStoriesData?.story
);

export const selectIsDeleted = createSelector(
  selectSuccessStories,
  state => state?.successStoriesData?.isDeleted
);
